import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

import {
    ConfirmationDialogData,
    ConfirmationDialogComponent,
} from '../dialogs';

@Injectable({
    providedIn: 'root'
})
export class DialogService {
    private _dialog = inject(MatDialog);



    constructor() {
    }

    public showConfirmation(data: ConfirmationDialogData): Observable<any> {
        const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
            width: '345px',
            data
        });
        return dialogRef.afterClosed();
    }
}
